import MissingPaymentDetails from './Icon';

export default MissingPaymentDetails;
